import * as yup from 'yup';

export const ProposalValidationSchema = yup.object({
	proposedFee: yup
		.number()
		.nullable()
		.min(0, 'Proposed bee must be greater than / equal to 0')
		.typeError('Proposed Fee must be a valid number')
		.transform((curr, orig) => (orig === '' ? null : curr)),

	depositRequired: yup
		.number()
		.nullable()
		.min(0, 'Deposit Required must be greater than 0')
		.max(100, 'Deposit Required must be less than or equal to 100')
		.typeError('Deposit Required must be a valid number')
		.transform((curr, orig) => (orig === '' ? null : curr)),

	statusId: yup
		.number()
		.nullable()
		.transform((curr, orig) => (orig === '' ? null : curr)),

	dateSent: yup.date().nullable().transform((curr, orig) => (orig === '' ? null : curr))
		.test('is-not-after-dateReceived', 'Date Sent cannot be after than Date Received', function (value) {
			const { dateReceived } = this.parent;
			if (value && dateReceived && value > dateReceived) {
				return false;
			}
			return true;
		}),
	dateReceived: yup.date().nullable().transform((curr, orig) => (orig === '' ? null : curr))
		.test('is-not-before-dateSent', 'Date Received cannot be before Date Sent', function (value) {
			const { dateSent } = this.parent;
			if (value && dateSent && value < dateSent) {
				return false;
			}
			return true;
		}),
	totalDepositRequired: yup.string().nullable(),
	totalBalance: yup.string().nullable(),
});
